import React from "react";
import styled from "styled-components";
import Label from "./Label";
import { errorStyles } from "./styles";

export const InputFieldContainer = styled.div`
  width: 100%;
  vertical-align: top;
`;
InputFieldContainer.displayName = "InputFieldContainer";

export const formatOrData = (formatter, data) =>
  formatter ? formatter(data) : data;

const InputElement = styled.input`
  ${errorStyles}
  width: 100%;
  display: block;
  font-family: ${(props) => props.theme.fonts.heading};
  font-weight: ${(props) => props.theme.fonts.weights.normal};
  font-size: 16px;
  padding: 15px;
  height: 48px;
  border-radius: initial;
  line-height: 1.5em;
`;

const TextareaElement = styled.textarea`
  ${errorStyles}
  width: 100%;
  display: block;
  font-family: ${(props) => props.theme.fonts.heading};
  font-weight: ${(props) => props.theme.fonts.weights.normal};
  font-size: 16px;
  padding: 15px;
  min-height: 120px;
  border-radius: initial;
  line-height: 1.5em;
  resize: vertical;
`;

const InputField = ({
  id,
  invalidText,
  error = true,
  visible = true,
  disabled,
  required,
  text,
  data,
  onChange,
  formatter,
  type = "text",
  multiline = false,
  rows = 4,
  labelStyles = {
    transform: "uppercase",
    fontSize: "12px",
    weight: "700",
  },
}) => {
  const Element = multiline ? TextareaElement : InputElement;
  const elementProps = {
    error,
    name: id,
    value: formatOrData(formatter, data),
    raw: data,
    onChange,
    disabled,
    ...(multiline ? { rows } : { type }),
  };

  return visible ? (
    <InputFieldContainer id={id} visible={visible}>
      <Label
        {...labelStyles}
        error={!error}
        marginVertical="8px"
        disabled={disabled}
      >
        {text} {required && <sup>*</sup>}
      </Label>
      <Element {...elementProps} />
      {!error && (
        <Label weight="500" error marginVertical="8px">
          {invalidText}
        </Label>
      )}
    </InputFieldContainer>
  ) : null;
};
InputField.displayName = "InputField";

export default InputField;
